import React from 'react';
import { Link } from 'react-router'
import Icon from '../Icon';
import styles from './arrow-link.scss'
import CSSModules from 'react-css-modules'

const ArrowLink = (props) => {
    const ico = !!props.icon ? <Icon styleName="icon" icon={ props.icon } /> : null;

    return (
        <Link styleName="link" to={ props.url }>
            <span styleName="inner">
                <span className="ellipsis" styleName="text">{ props.text }</span>
                { ico }
                <Icon styleName="icon-next" icon="Vitra_Next.svg" />
            </span>
        </Link>
    )
};

export default CSSModules(ArrowLink, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ArrowLink/index.jsx